import React, { useContext, useState, useEffect } from 'react'
import { ShopContext } from '../Context/ShopContext'
import { useParams } from 'react-router-dom';
import Breadcrum from '../Components/Breadcrum/Breadcrum';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import Description from '../Components/Description/Description';
import RelatedProduct from '../Components/RelatedProduct/RelatedProduct';




const Product = () => {
  // let {All_product}=useContext(ShopContext);
  let [All_product, setAllproduct] = useState([]);
  let { productId } = useParams();
  let [product, setproduct] = useState([]);
  const {url}=useContext(ShopContext)
  useEffect(() => {
    const fetch_data = async () => {
      try {
        await fetch(`${url}/allproduct`)
          .then((response) => response.json())
          .then((data) => {
           setproduct(data.find((e) => e.id === Number(productId)));
          });
      } catch (error) {
        console.log("server is down");
      }
    }
    fetch_data()
  })
  let cat=product.category;
  return (
    <div>
      <Breadcrum product={product} />
      <ProductDisplay product={product}/>
      <Description />
       <RelatedProduct check_category={cat} crt_product={product} productId={productId}/>
    </div>
  )
}

export default Product
